import { jsx as C } from "react/jsx-runtime";
import { SVG as e, Path as o } from "../template.js";
const a = ({
  pathProps: r,
  ...t
}) => /* @__PURE__ */ C(e, { ...t, children: /* @__PURE__ */ C(
  o,
  {
    ...r,
    d: "M21 11.5V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22H12.5M21 10H3M16 2V6M8 2V6M18 21V15M15 18H21"
  }
) });
export {
  a as default
};
